import axios from 'axios';

import { VITE_API_URL } from '@utils/getBaseUrl';

import { DEFAULT_LANG, SUPPORTED_LANGS } from '@i18n/languages';

export const api = axios.create({
  baseURL: VITE_API_URL,
});

api.interceptors.request.use(config => {
  const segments = window.location.pathname.split('/');
  const maybeLang = segments[1];

  const lang = SUPPORTED_LANGS.includes(maybeLang) ? maybeLang : DEFAULT_LANG;

  config.params = {
    ...(config.params || {}),
    lang,
  };

  return config;
});
